import React, { FC } from 'react';
import classNames from 'classnames';

import { useAppTranslation } from 'app/config/i18Config/hooks';
import { ProfileVerificationStatus } from 'entities/User';

import { ReactComponent as CheckIcon } from 'shared/assets/icons/CheckMark.svg';
import { ReactComponent as RejectIcon } from 'shared/assets/icons/CancelIcon.svg';
import { ReactComponent as ClockIcon } from 'shared/assets/icons/newIcons/ClockIcon.svg';
import { ReactComponent as PassportIcon } from 'shared/assets/icons/newIcons/PassportIcon.svg';

interface Props {
  status: ProfileVerificationStatus | null;
  withLabel?: boolean;
  size?: 'small' | 'medium';
}

export const VerificationStatusIndicator: FC<Props> = ({ status, withLabel = false, size = 'medium' }) => {
  if (!status) {
    return null;
  }

  const { t } = useAppTranslation(['profile', 'common']);

  // TODO: Import another icons from figma
  const statusInfo = {
    [ProfileVerificationStatus.APPROVED]: {
      color: 'text-green-600',
      icon: <CheckIcon className={classNames('[&>path]:stroke-green-600', size === 'small' ? 'w-4 h-4' : 'w-5 h-5')} />,
      label: t('Documents are approved'),
    },
    [ProfileVerificationStatus.REJECTED]: {
      color: 'text-red-600',
      icon: <RejectIcon className={classNames('[&>path]:stroke-red-500', size === 'small' ? 'w-4 h-4' : 'w-5 h-5')} />,
      label: t('Documents are rejected'),
    },
    [ProfileVerificationStatus.PENDING]: {
      color: 'text-white-500',
      icon: <ClockIcon className={classNames(size === 'small' ? 'w-4 h-4' : 'w-5 h-5')} />,
      label: t('Documents are being verifying'),
    },
    unverified: {
      color: 'text-gray-500',
      icon: <PassportIcon className="w-[20px] h-[20px] shrink-0" />,
      label: t('Documents are not uploaded'),
    },
  };

  const current = statusInfo[status || 'unverified'];

  return (
    <div className={classNames('flex items-center gap-2 mx-2', current.color)}>
      {current.icon}
      {withLabel && <span className="text-sm font-medium">{current.label}</span>}
    </div>
  );
};
